export default __webpack_public_path__ + "static/media/Outerpond-Logo.6fdaf0c8.png";